function distanceCalculator(start, end) {
  return new Promise((resolve, reject) => {
    // Check if Google Maps API is loaded
    if (!window.google || !window.google.maps) {
      reject(new Error("Google Maps JavaScript API not loaded"));
      return;
    }

    const service = new window.google.maps.DistanceMatrixService();

    service.getDistanceMatrix(
      {
        origins: [start],
        destinations: [end],
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.METRIC,
        drivingOptions: {
          // Use a Date object for the current time
          departureTime: new Date(),
          // BEST_GUESS provides the most likely travel time.
          trafficModel: window.google.maps.TrafficModel.BEST_GUESS
        }
      },
      (response, status) => {
        if (status !== "OK") {
          // console.error("DistanceMatrix Error:", status);
          reject(new Error("Failed to get distance"));
          return;
        }

        const element = response.rows[0].elements[0];
        if (element.status !== "OK") {
          reject(new Error("Invalid route"));
          return;
        }

        const distanceText = element.distance.text;
        const distanceValue = element.distance.value; // in meters

        // console.log(`Distance: ${distanceText} (${distanceValue} m)`);
        resolve(distanceValue / 1000); // return kilometers if you want
      }
    );
  });
}

export default distanceCalculator;


